import React from 'react';
import PropTypes from 'prop-types';
import { interpolate } from '@format/interpolate';
import { useShopifyOfferContext } from '../../offer/shopifyContext';
import { TrackedLink } from '../TrackedLink';
import { StyledCtaButton } from './styles.js';
import { ctaButtonClicked } from './events';

export const CtaButton = ({
  children,
  href,
  variant = 'primary',
  onClick,
  fullWidth = false,
  openNewTab = false,
  minWidth = 240,
  hoverIcon = 'arrow-forward',
  headerText = '',
  alignment = 'center',
}) => {
  const { formattedAmount } = useShopifyOfferContext();

  const getCtaPosition = href => {
    const params = new URLSearchParams(href.split('?')[1]);
    return params.get('cta_position');
  };

  const ctaPosition = getCtaPosition(href);
  const text = typeof children === 'string' ? children : null;
  const eventPayload = ctaButtonClicked(ctaPosition, href, text, headerText);

  return (
    // Would it make sense for CTA button to just extend LinkButton rather than wrap it?
    <StyledCtaButton $alignment={alignment}>
      <TrackedLink
        href={href}
        variant={variant}
        horizontalPadding={12}
        verticalPadding={4}
        minWidth={minWidth}
        onClick={onClick}
        hoverIcon={hoverIcon}
        fullWidth={fullWidth}
        target={openNewTab ? '_blank' : null}
        rel={openNewTab ? 'noopener noreferrer' : null}
        headerText={headerText}
        analyticsEvent={eventPayload}
      >
        {typeof children === 'string'
          ? interpolate(children, { offer: formattedAmount ?? ' 50%' })
          : children}
      </TrackedLink>
    </StyledCtaButton>
  );
};

CtaButton.displayName = 'CtaButton';

CtaButton.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  fullWidth: PropTypes.bool,
  openNewTab: PropTypes.bool,
  hoverIcon: PropTypes.string,
  headerText: PropTypes.string,
};
